import React, { forwardRef } from 'react';
import { IcoupleDetailItem } from '@typings/couple/couple.interface';
import BorderFrame from '@components/dataDisplay/Frame/BorderFrame';
import { CSSProperties } from 'styled-components';
import CoupleEditBtnSec from './CoupleEditBtnSec';

type Props = {
  collectionPath?: string;
  data?: IcoupleDetailItem;
  isEdit?: boolean;
  style?: CSSProperties;
};
function CoupleCard({ data, collectionPath, isEdit, ...props }: Props, ref) {
  if (!data) return null;

  return (
    <>
      <BorderFrame
        data={data}
        alignItems="center"
        collectionPath={collectionPath}
        countDdayFromStart
        ref={ref}
        {...props}
      >
        {data.character?.left.name} & {data.character?.right.name}
      </BorderFrame>
      {isEdit && (
        <CoupleEditBtnSec data={data} collectionPath={collectionPath} />
      )}
    </>
  );
}

export default forwardRef(CoupleCard);
